import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { GetProjectByIdFailure, GetProjectByIdRequest, GetProjectByIdReset, GetProjectByIdSuccess } from './actions';
import { HomeProject } from '@models/swagger';

export const featureKey = 'getProjectById';

export interface State {
  data: HomeProject | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GetProjectByIdFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(GetProjectByIdRequest, state => ({ ...state, error: null, loading: true })),
    on(GetProjectByIdSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(GetProjectByIdReset, state => ({ ...state, data: null, error: null, loading: false }))
  )(state, action);
}
